export default function Posts() {
    return <h1>Posts Page</h1>;
}
